export default __webpack_public_path__ + "static/hmeGraphic1-3bb216de939b8e13a52d94fc56c80b14.svg";